export const environment = {
  production: false,
  env: 'Testing',
  ApiUrl: 'https://mishthapitest.clavisco.com/',
};
